(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-yotpo-review-globals"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("shopify:section:load", function(){
    var api = new Yotpo.API(yotpo);
    api.refreshWidgets();
  });

  } catch(e) { console.error(e); }
})();
})();
